import { useQuery } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { Dropdown } from 'shopper/components/Dropdown';

import ErrorBoundary from 'components/ErrorBoundary';
import GenericError from 'components/GenericError';

import placeholder from 'lib/placeholder';
import { storeQueryKeys } from 'lib/queryKeys';

import { getStoresList } from 'services/store';

import Stores from './Stores';

const Overlay = dynamic(() => import('shopper/components/Overlay'), {
  ssr: false,
});

const StoresDropdown = ({ isOpen, openerRef, onClose }) => {
  const { data: stores = [] } = useQuery({
    queryKey: storeQueryKeys.list({ featured: true }),
    queryFn: ({ signal }) => getStoresList({ from: 'topbar' }, { signal }),
    enabled: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  return (
    <>
      {isOpen && <Overlay className="w-full" />}
      <Dropdown
        align="left"
        className="z-50 min-w-max rounded-3 bg-neutral-high-100 pt-4 shadow-[0px_0px_10px_0px_rgba(87,87,87,0.2)] dark:border dark:border-neutral-high-200 dark:bg-neutral-low-500"
        data-test-selector="stores-dropdown"
        id="stores-dropdown"
        open={isOpen}
        openerRef={openerRef}
        renderToHTML
        onClickOutside={onClose}
      >
        {stores && (
          <ErrorBoundary
            fallback={
              <div className="w-72">
                <GenericError
                  message={placeholder('errors.couldNotLoadStores')}
                />
              </div>
            }
          >
            <Stores
              showStoreImages={isOpen}
              stores={stores}
              onClose={onClose}
            />
          </ErrorBoundary>
        )}
      </Dropdown>
    </>
  );
};

StoresDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  openerRef: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
};

export default StoresDropdown;
